import * as Sentry from '@sentry/react';

const safeGetItem = (key) => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

export const getSentryRuntimeContext = () => ({
  bizId: safeGetItem('bizId') || undefined,
  language: safeGetItem('languageV2') || undefined,
  route: typeof window !== 'undefined' ? window.location.pathname : undefined,
  href: typeof window !== 'undefined' ? window.location.href : undefined,
});

export const applySentryRuntimeContext = (scope) => {
  const ctx = getSentryRuntimeContext();
  if (ctx.bizId) {
    scope.setTag('bizId', ctx.bizId);
  }
  if (ctx.language) {
    scope.setTag('language', ctx.language);
  }
  if (ctx.route) {
    scope.setTag('route', ctx.route);
  }
  scope.setContext('app', ctx);
};

export const setSentryUserContext = ({ uid, bizId, accessType, email } = {}) => {
  if (!uid) {
    Sentry.setUser(null);
    return;
  }

  Sentry.setUser({
    id: uid,
    ...(email ? { email } : {}),
  });

  if (bizId) {
    Sentry.setTag('bizId', bizId);
  }
  if (accessType) {
    Sentry.setTag('accessType', accessType);
  }
};
